import { createApi } from "@reduxjs/toolkit/query/react";
import { supabaseBaseQuery } from "./supabaseBaseQuery";

export const rootApi = createApi({
  reducerPath: "api",
  baseQuery: supabaseBaseQuery,
  keepUnusedDataFor: 300,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  tagTypes: [
    "Auth",
    "Attendance",
    "Substitution",
    "PlannerData", // Fast-path tag for main planner query only
    "PendingApproval", // Pending class/staff absences awaiting approval
    "SubstituteCandidates", // Per-lesson substitute-teacher picker list
    "FreedTeachers", // Teachers freed by a class trip — class-absence driven
    "Courses",
    "Enrollments",
    "Lessons",
    "Timetable",
    "DraftLessons",
    "Families",
    "Students",
    "Staff",
    "StaffAbsence",
    "Messaging",
    "Announcements",
    "Groups",
    "Admin",
    "Settings",
    "Abholen",
    "PickupAuth",
    "Classes",
    "ClassStats",
    "Proposals",
    "Stundenplan",
    "Klassenbuch",
    "Hausaufgaben",
    "Aufsichten",
    "ChangeLog",
    "AbwesendeNotes",
    "FlexPageInit",
    "FlexShowcaseAdmin",
    "FlexProposalPictures",
    "FlexProposalDocuments",
    "Umfrage",
    "UmfrageAdmin",
    "ClassDistribution",
    "Verteilung",
    "NewsletterEdition",
    "Klaerungen",
  ],

  endpoints: () => ({}),
});
